import Vue from 'vue'

import { Tag } from 'vant'
import { NoticeBar } from 'vant'
import { Button } from 'vant'
import { Image as VanImage } from 'vant'
import { Popup } from 'vant'
import { Divider } from 'vant'
import { RadioGroup, Radio } from 'vant'
import { Rate } from 'vant'
import { Field } from 'vant'
import { Cell, CellGroup } from 'vant'
import { Icon } from 'vant'
import { Notify } from 'vant'
import { Dialog } from 'vant'
import { List } from 'vant'
import { PullRefresh } from 'vant'
import { Grid, GridItem } from 'vant'
import { Uploader } from 'vant'
import { Loading } from 'vant'
import { NavBar } from 'vant'
import { Toast } from 'vant'
import { ActionSheet } from 'vant'
import { Tabbar, TabbarItem } from 'vant'
import { Tab, Tabs } from 'vant'
import { ImagePreview } from 'vant'
import { Picker } from 'vant';
import { Col, Row } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Search } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Lazyload } from 'vant';
import { Empty } from 'vant';
import { GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant';
import { SubmitBar } from 'vant';
import { Card } from 'vant';
import { Stepper } from 'vant';
import { Step, Steps } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { SwipeCell } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { DatetimePicker } from 'vant';
import { Overlay } from 'vant';
import { Form } from 'vant';
import { TreeSelect } from 'vant';
import { Switch } from 'vant';
import { Circle } from 'vant';
import { Area } from 'vant';
import { Cascader } from 'vant';
import { Badge } from 'vant';
import { CountDown } from 'vant';

Vue.use(Badge);
Vue.use(Cascader);
Vue.use(Area);
Vue.use(Circle);
Vue.use(Switch);
Vue.use(TreeSelect);
Vue.use(Form);
Vue.use(Overlay);
Vue.use(DatetimePicker);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(SwipeCell);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Stepper);
Vue.use(Card);
Vue.use(SubmitBar);
Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Empty);
Vue.use(Lazyload);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Search);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Col);
Vue.use(Row);
Vue.use(Picker);
Vue.use(ImagePreview)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(NavBar)
Vue.use(ActionSheet)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Uploader)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Icon)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Rate)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Divider)
Vue.use(Popup)
Vue.use(VanImage)
Vue.use(Button)
Vue.use(Tag)
Vue.use(NoticeBar)
Vue.use(Notify)
Vue.use(CountDown)
